import Marquee from "react-fast-marquee";

const PHRASES = ["Hygiene", "Dignity", "Prevention", "Education", "Community", "Compassion", "Wellness"];

export const EditorialMarquee = () => (
  <section data-testid="marquee" className="py-10 border-y hairline bg-[#F8FAFC] overflow-hidden">
    <Marquee speed={40} gradient={false} autoFill>
      {PHRASES.map((p, i) => (
        <div key={i} className="flex items-center">
          <span className="font-display italic text-4xl md:text-6xl text-brand-ink/80 px-8">{p}</span>
          <span className="h-2.5 w-2.5 rounded-full bg-brand-green" />
        </div>
      ))}
    </Marquee>
  </section>
);
